// extracted by mini-css-extract-plugin
module.exports = {"pager":"pagination_pager__1uEfQ","current":"pagination_current__CZNi0","richPager":"pagination_richPager__1-7Qb"};